import React, { ReactNode } from 'react';
import ProgressiveImage from './ProgressiveImage';
import ScrollReveal from './ScrollReveal';

interface HorizontalSectionProps {
  title: string;
  subtitle?: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
  imagePlaceholder: string;
  reverse?: boolean;
  children?: ReactNode;
  className?: string;
  ctaText?: string;
  onCtaClick?: () => void;
}

/**
 * Tesla-inspired horizontal section with image on one side and content on the other
 */
const HorizontalSection: React.FC<HorizontalSectionProps> = ({
  title,
  subtitle,
  description,
  imageSrc,
  imageAlt,
  imagePlaceholder,
  reverse = false,
  children,
  className = '',
  ctaText,
  onCtaClick,
}) => {
  return (
    <section className={`horizontal-container ${reverse ? 'horizontal-container--reverse' : ''} ${className}`}>
      <div className="horizontal-container__content">
        <ScrollReveal animation="fade-in-up" delay={200}>
          {subtitle && <div className="text-body-small text-uppercase letter-spacing-wider mb-2">{subtitle}</div>}
          <h2 className="text-heading-2 mb-6">{title}</h2>
          <p className="text-body mb-8">{description}</p>
          
          {ctaText && (
            <button 
              className="btn-primary" 
              onClick={onCtaClick}
            >
              {ctaText}
            </button>
          )}
          
          {children}
        </ScrollReveal>
      </div>
      
      <div className="horizontal-container__media">
        <ProgressiveImage
          src={imageSrc}
          placeholderSrc={imagePlaceholder}
          alt={imageAlt}
          aspectRatio="16:9"
        />
      </div>
    </section>
  );
};

export default HorizontalSection;